/// <amd-module name="Artifacts/Pypi/components/Logo" />
import { ILogoProps } from "Artifacts/Package/types/ILogoProps";
import * as PypiRes from "Artifacts/Pypi/Resources";
import * as React from "react";
import { Components, useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Image } from "VSSUI/Image";

export const logoContributionId = "ms.azure-artifacts.protocol-pypi.logo";

const Logo: React.FC<ILogoProps> = ({ className }) => {
  const { pageContext } = useComponentContext();

  return (
    <Image
      className={className}
      alt={PypiRes.Logo_PyPi}
      src={getAssetLocation(pageContext, "ms.azure-artifacts/protocol-pypi/img/python.svg")}
    />
  );
};

Components.add(logoContributionId, Logo);

export { Logo };
